import React from 'react';
import { Box, VStack, ScrollView } from 'native-base';
import { Caption } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {
    useEmailNotifications,
    useAcceptEmailNotification,
    useDeleteEmailNotification,
    useTheme,
} from '@springbig/shared';
import NotificationCard from './NotificationCard';

const NotificationsPage = () => {

    const { data, isLoading, refetch } = useEmailNotifications();
    const { mutate: acceptNotification, isLoading: isAccepting } = useAcceptEmailNotification();
    const { mutate: deleteNotification, isLoading: isDeleting } = useDeleteEmailNotification();
    const { primary } = useTheme();

    const notifications = data?.notifications || [];
    const email = data?.email || '';
    const lastEmailConfirmationSentAt = data?.last_email_confirmation_sent_at;

    const handleAccept = (notificationId: number, email?: string) => {

        acceptNotification({ notificationId, email }, {
            onSuccess: () => {

                refetch();
            },
        });
    };

    const handleDelete = (notificationId: number) => {

        deleteNotification(notificationId, {
            onSuccess: () => {

                refetch();
            },
        });
    };

    const renderContent = () => {

        if (isLoading) {
            return (
                <Box p={4}>
                    <Caption>Loading notifications...</Caption>
                </Box>
            );
        }

        if (notifications.length === 0) {
            return (
                <Box py={8} alignItems="center">
                    <SpIcon icon={faEnvelope} size={48} color="gray.400" />
                    <Caption mt={4}>No notifications</Caption>
                </Box>
            );
        }

        return (
            <VStack space={0}>
                {notifications.map((notification) => (
                    <NotificationCard
                        key={notification.id}
                        notification={notification}
                        onAccept={handleAccept}
                        onDelete={handleDelete}
                        isAccepting={isAccepting}
                        isDeleting={isDeleting}
                        primary={primary}
                        email={email}
                        lastEmailConfirmationSentAt={lastEmailConfirmationSentAt}
                    />
                ))}
            </VStack>
        );
    };

    return (
        <Box flex={1} bg="white">
            <ScrollView flex={1}>
                {renderContent()}
            </ScrollView>
        </Box>
    );
};

export default NotificationsPage;
